import React from 'react';

const Services = () => {
  return (
    <section className="about-area position-relative overflow-hidden space" id="sercices-sec">
      <div className="container">
        <div className="row">
          <div className="col-xl-6">
            <div className="img-box1">
              <div className="img1">
                <img className="img-fluid" src="/assets/img/normal/about_1_1.jpeg" alt="About" />
              </div>
              <div className="img2" style={{ paddingBottom: '20px' }}>
                <img className="img-fluid" src="/assets/img/normal/about_1_2.jpeg" alt="About" />
              </div>
              <br />
              <div className="img3">
                <img className="img-fluid" src="/assets/img/normal/about_1_3.jpeg" alt="About" />
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="ps-xl-4 ms-xl-2">
              <div className="title-area mb-20 pe-xl-5 me-xl-5">
                <span className="sub-title style1">Let's Go Together</span>
                <h2 className="sec-title mb-20 pe-xl-5 me-xl-5 heading">Plan Your Trip With us</h2>
                <p className="sec-text mb-30">
                  There are many variations of passages of available but the majority have suffered alteration in some form, by injected hum randomised words which don't look even slightly.
                </p>
              </div>
              <div className="about-item-wrap">
                <div className="about-item">
                  <div className="about-item_centent">
                    <h5 className="box-title">Exclusive Trip</h5>
                    <p className="about-item_text">
                      There are many variations of passages of available but the majority.
                    </p>
                  </div>
                </div>
                <div className="about-item">
                  <div className="about-item_centent">
                    <h5 className="box-title">Professional Guide</h5>
                    <p className="about-item_text">
                      There are many variations of passages of available but the majority.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-35">
                <a href="#contact-sec" className="th-btn style3 th-icon">Learn More</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;